import { type WorkflowStatusAttributes } from './generated/WorkflowStatusAttributes';
import { model } from '../modelBuilder';
import ApplicationModel, { attr } from '../ApplicationModel';
import ColorAttribute, {
  type IColorAttribute,
} from './concerns/ColorAttribute';

interface WorkflowStatus extends WorkflowStatusAttributes, IColorAttribute {}

@model
@ColorAttribute()
class WorkflowStatus extends ApplicationModel {
  // Start auto-generated
  static typename: 'WorkflowStatus' = 'WorkflowStatus';
  get typename(): 'WorkflowStatus' {
    return 'WorkflowStatus';
  }

  static internalTypename: 'WorkflowStatus' = 'WorkflowStatus';
  get internalTypename(): 'WorkflowStatus' {
    return 'WorkflowStatus';
  }

  static inputType = 'WorkflowStatusAttributes!';

  static fields = {
    builtIn: attr({ readable: true }),
    color: attr({ writable: true, readable: true }),
    createdAt: attr({ readable: true }),
    id: attr({ readable: true }),
    internalMeaning: attr({ writable: true, readable: true }),
    name: attr({ writable: true, readable: true }),
    position: attr({ writable: true, readable: true }),
    updatedAt: attr({ readable: true }),
    permissions: attr.belongsTo({
      readable: true,
      typename: 'ResourcePermissions',
    }),
    workflow: attr.belongsTo({
      writeShape: ['id'],
      readable: true,
      typename: 'Workflow',
    }),
  };
  // End auto-generated

  static ALL_INTERNAL_MEANINGS = [
    'NOT_STARTED',
    'IN_PROGRESS',
    'DONE',
    'SHIPPED',
    'WONT_DO',
    'ALREADY_EXISTS',
  ];

  static INTERNAL_MEANING_DESCRIPTIONS = {
    NOT_STARTED: 'Not started',
    IN_PROGRESS: 'In progress',
    DONE: 'Done',
    SHIPPED: 'Shipped',
    WONT_DO: 'Will not do',
    ALREADY_EXISTS: 'Already exists',
  };

  static INCOMPLETE_STATUSES = ['NOT_STARTED', 'IN_PROGRESS'];
  static COMPLETED_STATUSES = ['DONE', 'SHIPPED', 'WONT_DO', 'ALREADY_EXISTS'];
  static DELIVERED_STATUS = ['DONE', 'SHIPPED'];

  get isCompleted() {
    if (!this.internalMeaning) return false;
    return WorkflowStatus.COMPLETED_STATUSES.includes(this.internalMeaning);
  }

  get isInProgress() {
    return this.internalMeaning === 'IN_PROGRESS';
  }

  get isStarted() {
    return this.internalMeaning !== 'NOT_STARTED';
  }

  get isDelivered() {
    if (!this.internalMeaning) return false;

    WorkflowStatus.DELIVERED_STATUS.includes(this.internalMeaning);
  }
}

export default WorkflowStatus;
